<template>
  <div class="container">
    <div class="container row">
      <h1 class="semibold-font">{{ $t('contact_data') }}</h1>
    </div>
    <div class="container row">
      <div class="regular-font company-address">
        <strong>{{ companyName }}</strong><br>
        {{ companyStreet }}
      </div>
    </div>
    <div class="container row">
      <div class="regular-font company-address">
        {{ $t('email') }}: <span class="purple-color"><a :href="'mailto:' + companyEmail" @click="logContactEvent">{{ companyEmail }}</a></span><br>
        {{ $t('helpline') }}: <span class="purple-color"><a :href="'tel:' + companyHelpline" @click="logContactEvent">{{ companyHelpline }}</a></span><br>
        {{ $t('www') }}: <span class="purple-color">
          <a class="see-more" v-bind:href="'https://' + companyWWW" target="_blank">
            {{ companyWWW }}
          </a>
        </span>
      </div>
    </div>
    <div class="container row">
      <div class="regular-font company-address">
        {{ capitalGroupInfo }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { metaModule } from 'cuf-expo-bridge'
import contactDetailsHelper from '@/utils/contactDetails'

export default {
  name: 'Contact',
  computed: {
    ...mapGetters(['currentDocuments']),
    contactDetails () {
      return contactDetailsHelper.resolveContactDetails({
        locale: this.$i18n.locale,
        host: location.host,
        documents: this.currentDocuments
      })
    },
    capitalGroupInfo () {
      return contactDetailsHelper.capitalGroupInfo(location.host)
    },
    companyName () {
      return this.contactDetails.name
    },
    companyStreet () {
      return this.contactDetails.street
    },
    companyEmail () {
      return this.contactDetails.email
    },
    companyHelpline () {
      return this.contactDetails.helpline
    },
    companyWWW () {
      return this.contactDetails.www
    }
  },
  created () {
    // current_documents drives the CUF vs ETX contact choice; make sure it is loaded
    // even when the client deep-links straight to /contact before App.vue fetched it.
    if (!this.currentDocuments || !this.currentDocuments.length) {
      this.$store.dispatch('getInfo')
    }
  },
  methods: {
    logContactEvent () {
      metaModule.logEvent({ name: 'Contact', params: { language: this.$i18n.locale } })
    }
  }
}
</script>

<style lang="scss">
  .company-address {
    color: #707070
  }

  .purple-color {
    a {
      color: #d2116e;
      text-decoration: none;
    }

    /* unvisited link */
    a:link {
      color: #d2116e;
    }

    /* visited link */
    a:visited {
      color: #d2116e;
    }

    /* mouse over link */
    a:hover {
      color: #d2116e;
    }

    /* selected link */
    a:active {
      color: #d2116e;
    }
      }
</style>
